<template lang="html">
    <div>
        <table class="table assigned-members">
            <thead>
                <tr>
                    <th></th>
                    <th>Name</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="member in client.team_members">
                    <td><img class="spark-profile-photo" :src="member.photo_url" :alt="member.name"></td>
                    <td>{{ member.name }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('client', {
            'client': 'activeClient',
            'isAdmin': 'isAdmin',
        })
    },
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/AssignedTeamMembers.vue